import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';


const initialState = {
    data: {},
};

const blockInventorySlice = createSlice({
    name: 'blockInventory',
    initialState,
    reducers: {
        
        addBlockInventories(state, action) {
           state.data = action.payload;
        },
        emptyBlockInventories(state,action){
            state.data= {};
        }
    },
});

// Export action creators
export const {
    addBlockInventories,
    emptyBlockInventories
} = blockInventorySlice.actions;

// Reducer
export default blockInventorySlice.reducer;

 